package org.hs_soft.runmynesto.pages.home.sub_page.template.component.tabs.tab_general.component.select_days

import androidx.compose.runtime.Composable
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.borderTop
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.onMouseEnter
import com.varabyte.kobweb.compose.ui.modifiers.onMouseLeave
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.zIndex
import com.varabyte.kobweb.compose.ui.thenIf
import org.hs_soft.runmynesto.domain.config.Dimen
import org.hs_soft.runmynesto.domain.config.Theme
import org.hs_soft.runmynesto.domain.util.Constants
import org.hs_soft.runmynesto.pages.components.CheckboxComponent
import org.jetbrains.compose.web.css.LineStyle
import org.koin.core.definition.indexKey

@Composable
fun CheckBoxDay(
    isChecked: Boolean,
    title: String,
    onChecked: () -> Unit,
    onUnChecked: () -> Unit,
)
{
    val isHovered= remember { mutableStateOf(false) }

    Column(
       modifier = Modifier
           .backgroundColor(Theme.White.rgb)
           .zIndex(Constants.ZIndex.largeZIndex)
           .fillMaxWidth()
    ) {
        Row(
            modifier = Modifier
                .backgroundColor(
                    if (isChecked) Theme.PrimaryStatesSelected.rgb
                    else if (isHovered.value) Theme.PrimaryStatesHover.rgb
                    else Theme.White.rgb)

                .onMouseLeave { isHovered.value=false }
                .onMouseEnter { isHovered.value=true }
                .padding(Dimen.normalPadding)
                .fillMaxWidth()
        ){
            CheckboxComponent(
                modifier = Modifier,
                checkStatus = isChecked,
                title =title ,
                onChecked = {
                    onChecked()
                },
                onUnChecked = {
                    onUnChecked()
                },

            )


        }

    }

    
}